import React from "react";
import PropTypes from "prop-types";

import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "material-ui/Table";
import { dollarValue } from "./helpers/presentation";

const OvTimeInfoTable = props => {
  const { granularity, data } = props;
  const { unit } = granularity;

  const renderTableRows = () => {
    let format = "DD-MMM-YY HH:00";
    if (unit !== "hour") {
      format = "DD-MMM-YY";
    }

 

    return data
      .filter(
        d =>
          d.instance_cost > 0 ||
          d.license_cost > 0 ||
          d.storage_cost > 0 ||
          d.minutes > 0 ||
          d.cores > 0 ||
          d.storage > 0
      )
      .map((d, i) => {
        return (
          <TableRow key={i}>
            <TableCell numeric>{d.start_time.format(format)}</TableCell>
            <TableCell numeric>{dollarValue(d.license_cost)}</TableCell>
            <TableCell numeric>{dollarValue(d.instance_cost)}</TableCell>
            <TableCell numeric>{dollarValue(d.storage_cost)}</TableCell>
            <TableCell numeric>{d.cores.toFixed(3)}</TableCell>
            <TableCell numeric>{d.minutes.toFixed(2)}</TableCell>
            <TableCell numeric>{d.storage.toFixed(2)}</TableCell>
          </TableRow>
        );
      });
  };

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell numeric>Date</TableCell>
          <TableCell numeric>License cost</TableCell>
          <TableCell numeric>Instance cost</TableCell>
          <TableCell numeric>Storage cost</TableCell>
          <TableCell numeric>Cores</TableCell>
          <TableCell numeric>Minutes</TableCell>
          <TableCell numeric>Storage</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>{renderTableRows()}</TableBody>
    </Table>
  );
};

OvTimeInfoTable.propTypes = {
  granularity: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired
};

export default OvTimeInfoTable;



// WEBPACK FOOTER //
// ./src/OvTimeInfoTable.js